module.exports = __webpack_public_path__ + "img/m-banner-xzdvxwdm-es-ES.9349687d.jpg";